import { useQuery } from "@tanstack/react-query";
import { fetch } from "@/src/lib/fetch";
import { Amenity, AmenityDetails, Booking, Operator } from "../app/Bookings/model";

export function useBookingData(booking: Booking) {
  const { data: brokerData, isLoading: isLoadingBroker } = useQuery({
    queryKey: ["brokerData", booking.id],
    queryFn: () => fetch<{ broker: any }>(`/api/bookings/broker/${booking.id}`).then((res) => res),
    enabled: !!booking.id,
  });

  const {
    data: amenitiesData,
    isLoading: isLoadingAmenities,
    refetch: amenitiesRefetch,
  } = useQuery({
    queryKey: ["amenitiesData", booking.offerYacht?.id],
    queryFn: () => fetch<Amenity[]>(`/api/bookings/amenities/${booking.offerYacht?.id}`).then((res) => res),
    enabled: !!booking.offerYacht?.id,
  });

  const {
    data: amenitiesDetailsData,
    isLoading: isLoadingAmenitiesDetails,
    refetch: amenitiesDetailsRefetch,
  } = useQuery({
    queryKey: ["amenitiesDetailsData", booking.offerYacht?.id],
    queryFn: () =>
      fetch<{ amenitiesDetails: AmenityDetails[] }>(`/api/amenities/details/booking/${booking.id}`).then((res) => res),
    enabled: !!booking.id,
  });
  const { data: operatorData, isLoading: isLoadingOperator } = useQuery({
    queryKey: ["operatorData", booking.offerYacht?.yacht?.id],
    queryFn: () =>
      fetch<{ operator: Operator }>(`/api/operators/by-yacht/${booking.offerYacht?.yacht?.id}`).then((res) => res),
    enabled: !!booking.offerYacht?.yacht?.id,
  });

  const {
    data: operatorInvoiceFile,
    isLoading: isLoadingOperatorInvoiceFile,
  } = useQuery({
    queryKey: ["operatorInvoiceFile", "operator_invoice", booking.id],
    enabled: !!booking.id,
    queryFn: () =>
      fetch<{ status: "success"; data: { id: string; name: string; url: string } }>(
        `/api/files/file?ownerType=operator_invoice&ownerId=${booking.id}`
      ).then((r) => r.data),
  });


  return {
    brokerData: brokerData?.broker,
    amenitiesData: amenitiesData ?? [],
    amenitiesDetailsData: amenitiesDetailsData?.amenitiesDetails ?? [],
    operatorData: operatorData?.operator,
    operatorInvoiceFile, 
    isLoadingBroker: isLoadingBroker,
    isLoadingAmenities: isLoadingAmenities,
    isLoadingOperator: isLoadingOperator,
    isLoading: isLoadingBroker || isLoadingAmenities || isLoadingOperator,
    isLoadingOperatorInvoiceFile,
    fetchAmenities: amenitiesRefetch,
    fetchAmenitiesDetails: amenitiesDetailsRefetch,
  };
}
